import { UserPreferencesAPI } from '@weave/schema-gen-ts/dist/schemas/user-preferences/user_preferences.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaUserPreferences1Service = bindHTTP(UserPreferencesAPI);
